module.exports = __webpack_public_path__ + "static/media/screen5.cd0bcb5f.png";